<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap>
      <v-flex xs12 sm3>
        <v-card flat>
          <v-card-text>
            <div class="primary--text">Billing Details</div>
            <div v-if="schedule.billing_name">{{ schedule.billing_name }}</div>
            <div v-if="schedule.billing_address"> {{ schedule.billing_address }}</div>
            <div v-if="schedule.billing_city || schedule.billing_state || schedule.billing_postal_code">
              {{ schedule.billing_city }},
              {{ schedule.billing_state }}
              {{ schedule.billing_postal_code }}
            </div>
            <div v-if="schedule.billing_country && schedule.billing_country !== 'USA'"> {{ schedule.billing_country }}</div>
            <div v-if="schedule.billing_phone">{{ schedule.billing_phone }}</div>
            <div v-if="schedule.billing_email">{{ schedule.billing_email }}</div>
            <div v-if="schedule.billing_ip_address">{{ schedule.billing_ip_address }}</div>
          </v-card-text>
        </v-card>

        <v-card flat>
          <v-card-text>
            <div><span class="primary--text">{{ schedule.payment_type ? schedule.payment_type.toUpperCase() : '' }}</span> ************{{ schedule.last_four }}</div>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm9>
        <v-card flat>
          <v-card-text>
            <v-container fluid grid-list-xs pa-0 ma-0>
              <v-layout row wrap>
                <v-flex xs3 class="primary--text">ID</v-flex>
                <v-flex xs9>{{schedule.tracking_id}}</v-flex>

                <v-flex xs3 class="primary--text">Recurring</v-flex>
                <v-flex xs9 md3>
                  <span class="text-capitalize">{{ schedule.recurring_type }}</span>
                </v-flex>

                <v-flex xs3 class="primary--text">Status</v-flex>
                <v-flex xs9 md3>
                  <span class="text-capitalize">{{ schedule.recurring_status }}</span>
                </v-flex>

                <template v-if="parsedCustom && parsedCustom.migrated_from_transaction_id && hasPermission('can_view_migration')">
                  <v-flex xs3 class="primary--text">Migration</v-flex>
                  <v-flex xs9 md3>
                    <router-link :to="{ path: '/recurring', query: { id: parsedCustom.migrated_from_transaction_id } }">
                      <v-chip small outline color="info">Migrated from FAPS #{{ parsedCustom.migrated_from_transaction_id }}</v-chip>
                    </router-link>
                  </v-flex>
                </template>

                <v-flex xs3 class="primary--text">Start</v-flex>
                <v-flex xs9 md3>
                  <span class="text-capitalize">{{ dateUtc(schedule.start) }}</span>
                </v-flex>

                <v-flex xs3 class="primary--text">End</v-flex>
                <v-flex xs9 md3>
                  <span class="text-capitalize">{{ dateUtc(schedule.end) }}</span>
                </v-flex>

                <v-flex xs3 class="primary--text">Next Run</v-flex>
                <v-flex xs9 md3>
                  <span class="text-capitalize">{{ dateUtc(schedule.next_run) }}</span>
                </v-flex>

                <v-flex xs3 class="primary--text">Last Run</v-flex>
                <v-flex xs9 md3>
                  <span class="text-capitalize">{{ dateUtc(schedule.last_run) }}</span>
                </v-flex>

                <v-flex xs3 class="primary--text">Type</v-flex>
                <v-flex xs9 md3>
                  <span class="text-capitalize">{{ schedule.request_type }}</span>
                </v-flex>

                <v-flex xs3 class="primary--text">Account</v-flex>
                <v-flex xs9 md3>
                  <span class="text-capitalize">{{ schedule.account_name }}</span>
                </v-flex>

                <v-flex xs3 class="primary--text">Terminal</v-flex>
                <v-flex xs9 md3>
                  <span class="text-capitalize">{{ schedule.terminal_code }}</span>
                </v-flex>

                <v-flex xs3 class="primary--text">Total Amount</v-flex>
                <v-flex xs9 md3>{{ money(schedule.total_amount / 100) }}</v-flex>

                <template v-if="schedule.request_type === 'sale' && schedule.is_cashdiscount && !schedule.is_fee_waived">
                <v-flex xs3 class="primary--text">Fee Amount</v-flex>
                <v-flex xs9 md3>{{ money(schedule.fee_amount / 100) }}</v-flex>
                </template>

                <v-flex xs3 class="primary--text">Created</v-flex>
                <v-flex xs9 md3>{{ datetime(schedule.created) }}</v-flex>
                <v-flex xs3 class="primary--text">Updated</v-flex>
                <v-flex xs9 md3>{{ schedule.updated ? datetime(schedule.updated) : '' }}</v-flex>

                <v-flex xs3 class="primary--text">Created By</v-flex>
                <v-flex xs9 md3>{{ schedule.user_name ? schedule.user_name : (schedule.api_method === 'batch' ? 'batch' : '') }}</v-flex>

                <v-flex xs3 class="primary--text" v-if="schedule.customer_po">Customer PO</v-flex>
                <v-flex xs9 md3 v-if="schedule.customer_po">{{ schedule.customer_po }}</v-flex>
                <v-flex xs3 class="primary--text" v-if="schedule.custom_field_1">Custom 1</v-flex>
                <v-flex xs9 md3 v-if="schedule.custom_field_1" class="text-wrap">{{ schedule.custom_field_1 }}</v-flex>
                <v-flex xs3 class="primary--text" v-if="schedule.custom_field_2">Custom 2</v-flex>
                <v-flex xs9 md3 v-if="schedule.custom_field_2" class="text-wrap">{{ schedule.custom_field_2 }}</v-flex>
                <v-flex xs3 class="primary--text" v-if="schedule.custom_field_3">Custom 3</v-flex>
                <v-flex xs9 md3 v-if="schedule.custom_field_3" class="text-wrap">{{ schedule.custom_field_3 }}</v-flex>

                <v-flex xs3 class="primary--text" v-if="schedule.notes">Notes</v-flex>
                <v-flex xs9 md3 v-if="schedule.notes">{{ schedule.notes }}</v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-divider class="primary"></v-divider>

    <v-layout row wrap>
      <v-spacer></v-spacer>
      <v-btn v-if="schedule.schedule_group_custom_tracking_id" :to="{ name: 'PlanManage', query: { id: schedule.schedule_group_custom_tracking_id }}">Payment Plan</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      achStatusOptions: {
        1: 'Pending ACH authorization',
        2: 'Batched for processing',
        3: 'Pending bank approval',
        4: 'Approved',
        5: 'Declined'
      },

      enabled: false
    }
  },

  props: {
    schedule: Object
  },

  mounted () {},

  computed: {
    parsedCustom () {
      try {
        return this.schedule.custom ? JSON.parse(this.schedule.custom) : null
      } catch (e) {
        return null
      }
    },

    credited: function () {
      if (!this.schedule.hasOwnProperty('associatedTransactions') || this.schedule.associatedTransactions.length < 1) {
        return 0
      }

      let totalCredited = this.schedule.associatedTransactions.reduce((runningTotal, schedule) => {
        if ((schedule.request_type === 'credit' || schedule.request_type === 'achcredit') && schedule.response_code === '000' && schedule.parent_schedule_id === this.schedule.id) {
          return runningTotal + schedule.total_amount
        }
        return runningTotal
      }, 0)

      return totalCredited
    }
  },

  methods: {
    async authorize () {
      try {
        if (!this.schedule || !this.schedule.id) {
          throw new Error('Unable to identify schedule')
        }

        let options = {
          id: this.schedule.id,
          ach_is_authorized: true,
          ach_status_id: 2
        }

        let result = await this.api({
          method: 'put',
          url: `/schedules/${this.schedule.id}`,
          data: options
        })

        if (result.data && result.data.error === false) {
          // Bus.$emit('openModal', {status: 'success', message: 'Authorization accepted'})
          this.schedule.ach_is_authorized = true
          this.sendToProcessor()
          // Bus.$emit('optionsClose')
        } else {
          Bus.$emit('openModal', {status: 'error', message: 'Unexpected Error'})
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      }
    },

    printAuthorization () {
      this.$refs.achAuth.print()
    },

    async emailAuthorization () {
      try {
        if (!this.schedule || !this.schedule.id) {
          throw new Error('Unable to identify schedule')
        }

        let result = await this.api({
          method: 'get',
          url: `/schedules/${this.schedule.id}/send_authorization_email`
        })

        if (result.data && result.data.error === false) {
          Bus.$emit('openModal', {status: 'success', message: 'Email sent'})
        } else {
          Bus.$emit('openModal', {status: 'error', message: 'Unexpected Error'})
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      }
    },

    async sendToProcessor () {
      try {
        if (!this.schedule || !this.schedule.id) {
          throw new Error('Unable to identify schedule')
        }

        Bus.$emit('openWaitModal')
        let result = await this.api({
          method: 'post',
          url: `/terminal/submit`,
          data: {
            tracking_id: this.schedule.tracking_id
          }
        })
        Bus.$emit('closeWaitModal')

        if (result.data && result.data.response.ResponseText === 'CHECK ACCEPTED') {
          Bus.$emit('openModal', {status: 'success', message: 'Successfully sent to processor'})
          this.schedule.ach_is_authorized = true
          Bus.$emit('optionsClose')
        } else {
          let error = result.data.response.ResponseText
          if (result.data.response.ErrMsg) {
            error += ': ' + result.data.response.ErrMsg
          }
          Bus.$emit('openModal', {status: 'error', message: error})
        }
      } catch (err) {
        Bus.$emit('closeWaitModal')
        Bus.$emit('openModal', {status: 'error', message: err})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schedules/Details.vue